import React, { useCallback, useRef } from 'react';
import { CircularProgress, Dialog, IconButton, InputBase, Box, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClearIcon from '@mui/icons-material/Clear';
import SearchResults from './SearchResults';

export default function SearchDialog({
  open,
  fullScreen,
  onClose,
  searchTerm,
  results,
  filteredResults,
  hasResults,
  isLoading,
  isError,
  onChange,
  onCancel,
  onLinkClick,
  limit,
}) {
  const inputRef = useRef(null);

  const handleEntered = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  const handleClose = () => {
    onCancel();
    onClose();
  };

  const handleLinkClick = () => {
    onLinkClick();
    onClose();
  };

  const handleChange = e => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    onCancel();
    inputRef.current?.focus();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth={!fullScreen}
      data-test-id="search-dialog"
      TransitionProps={{ onEntered: handleEntered }}
      PaperProps={{
        sx: fullScreen ? {} : { mt: 8, alignSelf: 'flex-start', borderRadius: 3 },
      }}
    >
      <Stack direction="row" alignItems="center" sx={theme => ({ p: 1, borderBottom: `1px solid ${theme.palette.stoneGrey.base}` })}>
        <IconButton onClick={handleClose} aria-label="close search">
          <ArrowBackIcon />
        </IconButton>
        <InputBase
          inputRef={inputRef}
          value={searchTerm}
          onChange={handleChange}
          placeholder="Search for Clients or Itineraries"
          inputProps={{
            role: 'searchbox',
            'aria-label': 'global search',
          }}
          sx={{ flex: 1, mx: 1 }}
        />
        {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
        {searchTerm && !isLoading && (
          <IconButton size="small" onClick={handleClear} aria-label="clear">
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>
      <Box sx={{ overflow: 'auto', fontWeight: 400 }} data-test-id={hasResults ? 'search-results-container' : undefined}>
        {isError && searchTerm && <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>Search failed. Please try again.</Box>}
        {hasResults && (
          <SearchResults
            results={results}
            filteredResults={filteredResults}
            onLinkClick={handleLinkClick}
            limit={limit}
            compact={fullScreen}
          />
        )}
      </Box>
    </Dialog>
  );
}
